import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { CompanySetting } from './company-setting.model';

export const loadCompanySettings = createAction(
    '[CompanySetting/API] Load CompanySettings',
    props<{ companySettings: CompanySetting[] }>()
);

export const addCompanySetting = createAction(
    '[CompanySetting/API] Add CompanySetting',
    props<{ companySetting: CompanySetting }>()
);

export const upsertCompanySetting = createAction(
    '[CompanySetting/API] Upsert CompanySetting',
    props<{ companySetting: CompanySetting }>()
);

export const addCompanySettings = createAction(
    '[CompanySetting/API] Add CompanySettings',
    props<{ companySettings: CompanySetting[] }>()
);

export const upsertCompanySettings = createAction(
    '[CompanySetting/API] Upsert CompanySettings',
    props<{ companySettings: CompanySetting[] }>()
);

export const updateCompanySetting = createAction(
    '[CompanySetting/API] Update CompanySetting',
    props<{ companySetting: Update<CompanySetting> }>()
);

export const updateCompanySettings = createAction(
    '[CompanySetting/API] Update CompanySettings',
    props<{ companySettings: Update<CompanySetting>[] }>()
);

export const deleteCompanySetting = createAction(
    '[CompanySetting/API] Delete CompanySetting',
    props<{ id: string }>()
);

export const deleteCompanySettings = createAction(
    '[CompanySetting/API] Delete CompanySettings',
    props<{ ids: string[] }>()
);

export const clearCompanySettings = createAction(
    '[CompanySetting/API] Clear CompanySettings'
);

export const getCompanySettings = createAction(
    '[CompanySetting/API] Get CompanySettings'
);
export const getCompanySetting = createAction(
    '[CompanySetting/API] Get CompanySetting',
    props<{ SettingType: string }>()
);
export const putCompanySettings = createAction(
    '[CompanySetting/API] Put CompanySettings',
    props<{ settings: Array<Partial<CompanySetting>> }>()
);
